class Controller {
  constructor($mdDialog) {
    "ngInject";

    this.$mdDialog = $mdDialog;
    this.rejectionReason = "";
  }

  confirm() {
    if (!this.rejectionReason || this.rejectionReason < 10) return;
    this.$mdDialog.hide({ rejectionReason: this.rejectionReason });
  }

  close() {
    this.$mdDialog.cancel();
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/pendingBooking/rejectBooking/rejectBooking.controller.js